import angular from "angular";

import DateExtended from "serviceJs/date.service.ts";

import "../../../services/product";
import "../../../filters/html-to-plaintext";
import "./favorites";

import "../../products/favorites";

import ribbon from "../../../models/ProductRibbon";

angular.module("folkeuni").component("productsListItem", {
  bindings: {
    currentProgramUrl: "<",
    areaId: "<",
    siteId: "<",
    product: "<",
  },
  controller: function (Product) {
    var $ctrl = this;
    $ctrl.showDuration = true;
    $ctrl.ribbons = [];
    $ctrl.imageUrl = null;

    $ctrl.$onInit = function () {
      var setId = [2, 8, 9, 10, 18];
      const eventCount =
        $ctrl.product.events > 1 ? $ctrl.product.events + " gange" : "";
      $ctrl.product.durationFormatted = $ctrl.product.durationSummary
        ? $ctrl.product.durationSummary
        : eventCount;
      $ctrl.product.startDateFormattet = window.formatDates(
        $ctrl.product.startDate,
        $ctrl.product.durationFormatted,
        $ctrl.showDuration
      );
      $ctrl.imageUrl = $ctrl.product.imageCropUrl
        ? $ctrl.product.imageCropUrl
        : null;

      if (setId.indexOf($ctrl.siteId) > -1) {
        $ctrl.showDuration = false;
      }

      Product.ticketStatus($ctrl.siteId, $ctrl.product).then(
        function (updatedProduct) {
          updatedProduct.description = updatedProduct.description.replace(
            /&nbsp;/g,
            " "
          );
          if (updatedProduct.startDate && updatedProduct.startDateEnd) {
            var startDate = new Date(updatedProduct.startDate).setHours(
              0,
              0,
              0,
              0
            );
            var endDate = new Date(updatedProduct.startDateEnd).setHours(
              0,
              0,
              0,
              0
            );
          }

          updatedProduct.firstEventIsOneDay = startDate == endDate;
          $ctrl.product.startDateFormattet += $ctrl.product.firstEventIsOneDay
            ? new DateExtended($ctrl.product.startDateEnd).format(
                " - [HH].[mm]"
              )
            : "";
          $ctrl.product = updatedProduct;
          $ctrl.handleRibbons();
        },
        function (errorResponse) {}
      );

      if ($ctrl.product.ticketStatus) {
        $ctrl.product.inActiveStatus =
          ["soldOut", "cancelled"].filter(
            (entry) => entry == $ctrl.product.ticketStatus.class
          ).length !== 0;
      }
    };

    $ctrl.handleRibbons = () => {
      let state = getRibbon();
      if (state != null) {
        $ctrl.ribbons.push(state);
      }

      function getRibbon() {
        if ($ctrl.product.cancelled && $ctrl.areaId != 7) {
          return new ribbon({
            text: "Aflyst",
            styleClass: "cancelled",
          });
        }

        if ($ctrl.product.ended) {
          return new ribbon({
            text: "Afsluttet",
            styleClass: "started",
          });
        }

        if (
          $ctrl.product.ticketStatus &&
          (($ctrl.areaId == 7 &&
            $ctrl.product.ticketStatus.title != "AFLYST") ||
            $ctrl.areaId != 7)
        ) {
          return new ribbon({
            text: $ctrl.product.ticketStatus.title.charAt(0).toUpperCase() + $ctrl.product.ticketStatus.title.slice(1).toLowerCase(),
            styleClass: $ctrl.product.ticketStatus.class,
          });
        }

        if (new Date($ctrl.product.startDateEnd) < new Date()) {
          return new ribbon({
            text: "Startet",
            styleClass: "started",
          });
        }

        return null;
      }
    };
  },
  templateUrl:
    "/shop-dist/templates/products-list-item.html?c=" + window.cacheBurst,
});
